import styled from '@emotion/styled';

export const FormWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.savory.spacing[3]};
`;
